type Props = {
  heading: string;
  description: string;
  step: number;
  maxSteps: number;
};

const StepHeader = ({ heading, description, step, maxSteps }: Props) => {
  return (
    <div>
      <div className={"mb-1.5 flex justify-between gap-3"}>
        <h1 className={"text-xl font-semibold text-primary"}>{heading}</h1>
        <div className={"text-sm text-quaternary"}>
          {step} / {maxSteps}
        </div>
      </div>
      <p className={"text-left text-sm text-quaternary"}>{description}</p>
    </div>
  );
};

export default StepHeader;
